import { UnderSectionDto } from './under-section-dto.model';


export class InvestmentSchemaDto implements IInvestmentSchemaDto {
    id!: number | undefined;
    financialYear!: string | undefined;
    underSection!: UnderSectionDto;
    schemaName!: string | undefined;
    fromAmount!: number;
    toAmount!: number;
    maxAllowAmount!: number;
    allowPercentage!: number;
    isActive!: boolean;

    constructor(data?: IInvestmentSchemaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.financialYear = _data["financialYear"];
            this.underSection = _data["underSection"] ? UnderSectionDto.fromJS(_data["underSection"]) : <any>undefined;
            this.schemaName = _data["schemaName"];
            this.fromAmount = _data["fromAmount"];
            this.toAmount = _data["toAmount"];
            this.maxAllowAmount = _data["maxAllowAmount"];
            this.allowPercentage = _data["allowPercentage"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): InvestmentSchemaDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentSchemaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["financialYear"] = this.financialYear;
        data["underSection"] = this.underSection ? this.underSection.toJSON() : <any>undefined;
        data["schemaName"] = this.schemaName;
        data["fromAmount"] = this.fromAmount;
        data["toAmount"] = this.toAmount;
        data["maxAllowAmount"] = this.maxAllowAmount;
        data["allowPercentage"] = this.allowPercentage;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IInvestmentSchemaDto {
    id: number | undefined;
    financialYear: string | undefined;
    underSection: UnderSectionDto;
    schemaName: string | undefined;
    fromAmount: number;
    toAmount: number;
    maxAllowAmount: number;
    allowPercentage: number;
    isActive: boolean;
}

